"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _reactRedux = require("react-redux");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _modals = require("../../utils/modals");
var styles = {
  "modal": "DeleteVersionsModal__modal__2-Nlb",
  "header": "DeleteVersionsModal__header__1oeYm",
  "body": "DeleteVersionsModal__body__2z3kh",
  "footer": "DeleteVersionsModal__footer__2SkAp",
  "title": "DeleteVersionsModal__title__1ZLLK",
  "modal-lg": "DeleteVersionsModal__modal-lg__2jttd",
  "modalLg": "DeleteVersionsModal__modal-lg__2jttd"
}; 
require('./DeleteVersionsModal.css');
var AssetPortalVersionsTable = function AssetPortalVersionsTable(props) {
  var VersionsTable = (0, _exchangeReactHooks.useVersionsTable)();
  return /*#__PURE__*/_react.default.createElement(VersionsTable, props);
};
var DeleteVersionsModal = function DeleteVersionsModal(_ref) {
  var asset = _ref.asset,
    className = _ref.className,
    theme = _ref.theme;
  var labelId = 'delete-versions-modal-title';
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    closeModal = _useModals.closeModal;
  var isDraft = (0, _exchangeReactHooks.useIsPortalDraft)();
  var isEdit = (0, _exchangeReactHooks.useIsPortalEdit)();
  var canEdit = (0, _reactRedux.useSelector)(function (state) {
    return _assets.selectors.canShowEdition(state, asset);
  });
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    renderInBody: false,
    testId: "delete-versions-modal",
    onEsc: function onEsc() {
      return closeModal();
    },
    onClickOverlay: function onClickOverlay() {
      return closeModal();
    },
    className: (0, _classnames.default)(styles.modal, styles.modalLg, className),
    ariaLabelledBy: labelId,
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    className: styles.header,
    testId: "delete-versions-header",
    onClose: function onClose() {
      return closeModal();
    }
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: styles.title,
    id: labelId,
    "data-test-id": "delete-versions-title"
  }, "Delete patch versions for ", asset.minorVersion)), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    testId: "delete-versions-body",
    className: styles.body
  }, /*#__PURE__*/_react.default.createElement(AssetPortalVersionsTable, {
    asset: asset,
    isDraft: isDraft,
    isEdit: isEdit,
    canEdit: canEdit,
    isDeleteVersionsTable: true,
    useOpenModal: false
  })), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, {
    testId: "delete-versions-footer",
    className: styles.footer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    testId: "delete-versions-close-button",
    kind: "tertiary",
    onClick: function onClick() {
      return closeModal();
    },
    noFill: true
  }, "Close")));
};
var DeleteVersionsModalContainer = (0, _modals.setModalName)('DeleteVersionsModal')(DeleteVersionsModal);
var _default = exports.default = DeleteVersionsModalContainer;
//# sourceMappingURL=DeleteVersionsModal.js.map